<template>
    <div class="searchList">
        <div class="content-width">
            <el-row class="cccColor">
                <el-col>
                    <span class="searchColor">{{queryContent}}</span>&nbsp;&nbsp;
                    <span>搜索结果</span>
                </el-col>
            </el-row>
            <el-row
                :gutter="20"
                v-for="(item,index) in searchList"
                :key="index"
                class="outer-row-per"
            >
                <el-col :span="6">
                    <!-- 除文库 -->
                  <div
                        class="img-outer common-img-outer shou"
                        @click="goDetail(item.table,item.id,item.type)"
                        v-if="item.table != '4'">
                        <img :src="$store.state.imgUrl+item.imgUrl" alt style="height:100%" v-if="item.imgUrl" />
                        <img src="../assets/img/gf.png" alt style="height:100%" v-else-if="item.table === '11'" />
                        <img src="../assets/img/zhanwei.png" alt style="height:100%" v-else />
                    </div>
                    <!-- 文库 -->
                    <div
                        class="img-outer common-img-outer shou"
                        v-else
                        @click="goDetail(item.table,item.id,item.type)">
                        <img src="../assets/img/13.png" alt style="height:100%" />
                        <div class="one-book-title-box start-left-right-end-shu">{{item.name}}</div>
                    </div>
                </el-col>
                <el-col :span="18">
                    <div @click="goDetail(item.table,item.id,item.type)">
                        <div class="search-name shou">
                            {{item.name}}
                            <span
                                v-if="item.table == '9'"
                            >&nbsp;&nbsp;{{'('+item.pinyinName+')'}}</span>
                        </div>
                        <!-- 中草药 -->
                        <div v-if="item.table == '9'" class="search-content shou">
                            <div>别名:{{item.drugAlias}}</div>
                            <div>药性:{{item.medicine}}&nbsp;&nbsp;&nbsp;药味:{{item.pill}}&nbsp;&nbsp;&nbsp;归经:{{item.channelTropism}}&nbsp;&nbsp;&nbsp;药用部位:{{item.medicinalPart}}</div>
                            <div>药品功效:{{item.efficacyDrugs}}</div>
                        </div>
                        <!-- 经络 -->
                        <div v-if="item.table == '5'" class="search-content shou">
                            <div>
                                经脉循行:
                                <span v-html="item.des"></span>
                            </div>
                        </div>
                        <!-- 穴位 -->
                        <div v-if="item.table == '6'" class="search-content shou">
                            <!-- <div>{{item.position}}</div> -->
                            <div>
                                穴名释义:
                                <span>{{item.des}}</span>
                            </div>
                        </div>
                        <!-- 文库 -->
                        <div v-if="item.table == '4'" class="search-content shou">
                            <div>年代:{{item.year}}&nbsp;&nbsp;&nbsp;章节:{{item.chapter}}&nbsp;&nbsp;&nbsp;作者:{{item.author}}</div>
                            <div>文库简述:{{item.des}}</div>
                        </div>
                        <!-- 讲堂 -->
                        <div v-if="item.table == '3'" class="search-content shou">
                            <div>作者:{{item.author}}</div>
                            <div>讲堂简述:{{item.des}}</div>
                        </div>
                        <!-- 商品 -->
                        <div v-if="item.table == 'sp_spgl'" class="search-content shou">
                            <div>商品功效与作用:{{item.des}}</div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-pagination
                        background
                        layout="total,prev, pager, next,jumper"
                        :total="pageInfo2.total"
                        :page-size="pageInfo2.pageSize"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: "searchList",
    data() {
        return {
            queryContent: "" //搜索内容
        };
    },
    watch: {
        $route: {
            handler() {
                this.queryContent = this.$route.query.content;
                this.getResult(this.queryContent);
                //深度监听，同时也可监听到param参数变化
            },
            deep: true
        }
    },
    methods: {
        //选页
        handleCurrentChange(v) {
            let that = this;
            // console.log(v);
            that.pageInfo2.pageNum = v; //当前页
            that.getResult(that.queryContent);
        },

        // 去详情
        goDetail(table, id, type) {
            let that = this;
            if (table == "3") {
                // 讲堂
                if (type == "0") {
                    // 视频
                    that.$router.push({
                        path: "/ForumDetailv",
                        query: { id: id }
                    });
                } else {
                    //图文
                    that.$router.push({
                        path: "/ForumDetailw",
                        query: { id: id }
                    });
                }
            } else if (table == "4") {
                // 文库
                that.$router.push({
                    path: "/weiKuDetail",
                    query: { id: id }
                });
            } else if (table == "6") {
                // 穴位
                that.$router.push({
                    path: "/xueWeiDetail",
                    query: { id: id }
                });
            } else if (table == "5") {
                // 经络
                that.$router.push({
                    path: "/JingLuoDetail",
                    query: { id: id }
                });
            } else if (table == "9") {
                // 中草药
                that.$router.push({
                    path: "/HerbalMedicineDetail",
                    query: { id: id }
                });
            } else  if (table == "11") {
                // 古方大全
                that.$router.push({
                  path: "/ancPreDetail",
                  query: { id: id }
                });
            } else if (table == "sp_spgl") {
                // 商品
                that.$router.push({ path: "/ProductDetails/" + id });
            } else {
                console.log("都不是");
            }
        }
    },
    created() {
        let that = this;
        if (!!that.$route.query.content) {
            that.queryContent = that.$route.query.content;
            that.getResult(that.queryContent);
        }
    }
};
</script>

<style scoped>
.one-book-title-box {
    height: 66px;
    padding: 3px 0px;
    background-color: #ffffff;
    border: solid 1px #6c6b69;
    font-size: xx-small;
    /* line-height: 17px; */
    color: #444444;
    position: absolute;
    top: 28%;
    left: 9%;
    text-align: center;
    /* cursor: pointer; */
    word-wrap: break-word;
}
.search-content {
    font-size: 14px;
    color: #666666;
    letter-spacing: 1.4px;
    line-height: 32px;
}
.outer-row-per {
    margin-bottom: 10px;
}
.img-outer {
    width: 200px;
    height: 150px;
    border: 1px solid #f5f5f5;
}
.search-name {
    font-size: 20px;
    color: #333333;
    border-bottom: 1px solid #dddddd;
    padding-bottom: 10px;
    margin-bottom: 10px;
}
.cccColor {
    background-color: #fbfbfb;
    padding: 5px;
    margin-bottom: 30px;
}
.searchColor {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/searchList.vue